// The assign destination as a person should read it.
//
// `assignedLocation` holds a machine key: one of our own site names, or
// `supplier:<key>` for a production partner (issue #728). A partner key is not
// for human eyes, so the recipient captured on the case at assign time stands in
// — that is the name the customer was actually given.

const SUPPLIER_PREFIX = 'supplier:';

export function isSupplierLocation(rma) {
  return String((rma && rma.assignedLocation) || '').startsWith(SUPPLIER_PREFIX);
}

export function locationLabel(rma) {
  const key = (rma && rma.assignedLocation) || '';
  if (!key.startsWith(SUPPLIER_PREFIX)) return key;
  const recipient = String((rma && rma.assignedAddress) || '').split('\n')[0].trim();
  return recipient || key.slice(SUPPLIER_PREFIX.length).toUpperCase();
}

/** The shipping address on one line, from the snapshot taken when assigned. */
export function locationAddress(rma, fallback = '') {
  const snapshot = String((rma && rma.assignedAddress) || '').trim();
  if (!snapshot) return fallback;
  return snapshot.split('\n').map(line => line.trim()).filter(Boolean).join(', ');
}
